import categories from './categories/routes'

const FaqsIndex = () => import('./views/FaqsIndex.vue')
const FaqsCreate = () => import('./views/FaqsCreate.vue')
const FaqsEdit = () => import('./views/FaqsEdit.vue')

const sectionPrefix = 'faqs'

export default [
  {
    path: sectionPrefix,
    name: `${sectionPrefix}.index`,
    component: FaqsIndex
  },
  {
    path: `${sectionPrefix}/create`,
    name: `${sectionPrefix}.create`,
    component: FaqsCreate
  },
  {
    path: `${sectionPrefix}/:${sectionPrefix}Id(\\d+)`,
    name: `${sectionPrefix}.edit`,
    component: FaqsEdit
  },
  ...categories
]
